import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import TimelapseOutlinedIcon from '@mui/icons-material/TimelapseOutlined';
import OutboundOutlinedIcon from '@mui/icons-material/OutboundOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import SmsFailedOutlinedIcon from '@mui/icons-material/SmsFailedOutlined';
import { PortalNames } from "common/Portals";

export const SidebarData = {
    getItems: (groupType) => {
        var sidebarItems = 
        [
            {
                title: "Dashboard",
                icon: <DashboardOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Dashboard}`,
                index: 0
            },
            {
                title: "Important Messages",
                icon: <MessageOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Messages}`,
                index: 1
            },
            {
                title: "Benefits",
                icon: <PersonPinCircleOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Benefits}`,
                index: 3,
            },
            // {
            //     title: "Feedback",
            //     icon: <SmsFailedOutlinedIcon />,
            //     link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Feedback}`,
            //     index: 6,
            // },
        ]

        if (groupType !== "GSG") {
            sidebarItems.push({
                title: "Time Sheet",
                icon: <QueryBuilderOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.TimeSheet}`,
                index: 2,
            });
            
            sidebarItems.push({
                title: "Hourbank",
                icon: <TimelapseOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Hourbank}`,
                index: 2,
            });
            sidebarItems.push({
                title: "Excess Allocation",
                icon: <OutboundOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Excess}`,
                index: 2,
            });
            sidebarItems.push({
                title: "H&W Statements",
                icon: <HowToRegOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.HWStatements}`,
                index: 4,
            });
            
            sidebarItems.push({
                title: "Files",
                icon: <DescriptionOutlinedIcon />,
                link: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Files}`,
                index: 5,
            });
        }

        sidebarItems = sidebarItems.sort((a,b) => a.index - b.index);

        return sidebarItems;
    }
}
